import React, { useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../Context/LanguageContext'; // <-- IMPORTANT
import './CSS/Contact.css';

const Contact = () => {
  const { t } = useLanguage(); // <-- get translations

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [responseMessage, setResponseMessage] = useState('');

  const handleContactSubmit = async (e) => {
    e.preventDefault();

    const contactData = { name, email, phone, subject, message };

    try {
      const response = await axios.post('https://weynibirhan.com.et/contact.php', contactData);
      setResponseMessage(response.data.message);
    } catch (error) {
      setResponseMessage('Error sending the contact message.');
    }
  };

  return (
    <div className="contact-page-container">
      <div className="contact-page-form">

        <h2>{t.contact_title}</h2>

        <form onSubmit={handleContactSubmit}>

          <input
            type="text"
            placeholder={t.contact_name}
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="contact-page-input"
          />

          <input
            type="text"
            placeholder={t.contact_phone}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="contact-page-input"
          />

          <input
            type="email"
            placeholder={t.contact_email}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="contact-page-input"
          />

          <select
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="contact-page-input"
          >
            <option value="">{t.contact_subject}</option>
            <option value="vacancy">{t.subject_vacancy}</option>
            <option value="website">{t.subject_website}</option>
            <option value="webApp">{t.subject_webapp}</option>
            <option value="mobileApp">{t.subject_mobileapp}</option>
            <option value="software">{t.subject_software}</option>
            <option value="dashboard">{t.subject_dashboard}</option>
            <option value="consultancy">{t.subject_consultancy}</option>
            <option value="other">{t.subject_other}</option>
          </select>

          <textarea
            placeholder={t.contact_message}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="contact-page-textarea"
          />

          <button type="submit" className="contact-page-button">
            {t.contact_send}
          </button>

        </form>

        {responseMessage && (
          <p className="contact-page-response-message">
            {responseMessage}
          </p>
        )}

      </div>
    </div>
  );
};

export default Contact;
